// Dental education articles and videos (v1).
import axios from 'axios';
import api, {items} from './client';

export const getAllDentalKnowledge = () => api.get('/education?page_size=100').then((r) => items(r.data));

export const getDentalKnowledge = (id) => api.get(`/education/${id}`).then((r) => r.data);

/** Articles store either markdown or a URL to a markdown file (legacy content). */
export const getDentalKnowledgeMarkdown = async (content) => {
  if (typeof content === 'string' && /^https?:\/\//.test(content.trim())) {
    const res = await axios.get(content.trim());
    return res.data;
  }
  return content || '';
};

export const getDentalVideos = async (category) => {
  try {
    const r = await api.get(`/videos?page_size=100&category=${encodeURIComponent(category)}`);
    return items(r.data);
  } catch {
    return [];
  }
};
